import { Mesh, Object3D } from 'three'

export const isMesh = (obj: Object3D): obj is Mesh => 'isMesh' in obj
